import { Link } from "react-router-dom";
import { Lockup } from "../components/Logo";

const IMG = "https://static.prod-images.emergentagent.com/jobs/b9979ec9-3304-4896-8d2c-2eeafd09334a/images/0ee8dbd954966d9f82ebf08ff2344b8d25c73b184d9076d75ffef24ad16c43a7.jpeg";

export default function Story() {
  return (
    <div data-testid="story-page">
      <section className="container-hw grid gap-12 py-16 lg:grid-cols-12 lg:py-24">
        <div className="lg:col-span-6">
          <p className="eyebrow rise">Our story</p>
          <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl">H&amp;W stands for Husband &amp; Wife.</h1>
          <div className="rise d2 mt-8 space-y-5 text-lg leading-relaxed text-muted-foreground">
            <p>We started as two people in a 2BHK in Kondapur with too many books and nowhere to put them. Everything we liked was either flimsy, overpriced, or too big to get into our building's lift.</p>
            <p>So we designed a rack that came flat, went together with one hex key, and could take another shelf later. We built it on the floor over chai. Then friends across Hyderabad asked for one.</p>
            <p>That rack became the Pustak Rack, and H&amp;W became a do-it-yourself modular furniture company. We are Hyderabad-only for now: we deliver across the city ourselves in 1 to 2 days, and we sell direct, so the price you see is honest.</p>
          </div>
          <Link to="/product/pustak-rack" data-testid="story-shop-button" className="btn-sheesham mt-10">Start with the Pustak Rack</Link>
        </div>
        <div className="relative lg:col-span-6">
          <img src={IMG} alt="A Hyderabad couple building their Pustak Rack" className="aspect-[4/5] w-full rounded-md object-cover" />
          <img src="/brand/app-icon.png" alt="" className="absolute -bottom-8 -left-6 h-24 w-24 sm:h-28 sm:w-28" />
        </div>
      </section>
      <section className="bg-walnut py-20 text-linen">
        <div className="container-hw grid items-center gap-10 sm:grid-cols-4">
          <Lockup stacked reverse className="h-36" />
          {[["1 to 2 days", "free delivery across Hyderabad"], ["1 hex key", "to build it yourself"], ["0", "carpenters needed"]].map(([n, l]) => (
            <div key={l}><p className="font-display text-5xl text-brass">{n}</p><p className="mt-2 text-linen/75">{l}</p></div>
          ))}
        </div>
      </section>
    </div>
  );
}
